import { Input } from '@mairistem/composants';
import { ListeTable, OnKeyDownHandler } from '@mairistem/liste';
import React from 'react';

import type { ProduitsListeItemDetailType } from '@/types/produit';

interface ProduitsListeTableRowDetailProps {
  item: ProduitsListeItemDetailType;
  rowProps: Record<string, unknown>;
  utilities?: Record<string, any>;
}

const ProduitsListeTableRowDetail = (props: ProduitsListeTableRowDetailProps) => {
  const { item, rowProps, utilities } = props;

  const {
    identifiant,
    article,
    codeProduitLocal,
    fonction,
    ventilation,
    compteAnalytique,
    compteAnalytique2,
    siret,
    codeCollectivite,
    codeBudget,
  } = item;

  const handleChange = React.useCallback(
    (e, { name, value }) => {
      utilities?.onChange({ [name]: value });
    },
    [utilities],
  );

  if (utilities) {
    return (
      <ListeTable.Row key={identifiant} {...rowProps}>
        <ListeTable.Cell name="article" stretched>
          <Input
            name="article"
            fluid
            transparent
            value={article}
            onChange={handleChange}
            autoFocus={utilities?.autoFocus}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="codeProduitLocal" stretched>
          <Input
            name="codeProduitLocal"
            fluid
            transparent
            value={codeProduitLocal}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="fonction" stretched>
          <Input
            name="fonction"
            fluid
            transparent
            value={fonction}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="compteAnalytique" stretched>
          <Input
            name="compteAnalytique"
            fluid
            transparent
            value={compteAnalytique}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="compteAnalytique2" stretched>
          <Input
            name="compteAnalytique2"
            fluid
            transparent
            value={compteAnalytique2}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="ventilation" stretched>
          <Input
            name="ventilation"
            fluid
            transparent
            value={ventilation}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="siret" stretched>
          <Input
            name="siret"
            fluid
            transparent
            value={siret}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="codeCollectivite" stretched>
          <Input
            name="codeCollectivite"
            fluid
            transparent
            value={codeCollectivite}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
        <ListeTable.Cell name="codeBudget" stretched>
          <Input
            name="codeBudget"
            fluid
            transparent
            value={codeBudget}
            onChange={handleChange}
            {...utilities?.disableFocus}
            {...utilities?.disableDrag}
            onKeyDown={utilities?.onKeyDown([
              OnKeyDownHandler.validateOnEnter,
              OnKeyDownHandler.rollbackOnEsc,
            ])}
          />
        </ListeTable.Cell>
      </ListeTable.Row>
    );
  }

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell name="article">{article}</ListeTable.Cell>
      <ListeTable.Cell name="codeProduitLocal">{codeProduitLocal}</ListeTable.Cell>
      <ListeTable.Cell name="fonction">{fonction}</ListeTable.Cell>
      <ListeTable.Cell name="compteAnalytique">{compteAnalytique}</ListeTable.Cell>
      <ListeTable.Cell name="compteAnalytique2">{compteAnalytique2}</ListeTable.Cell>
      <ListeTable.Cell name="ventilation">{ventilation}</ListeTable.Cell>
      <ListeTable.Cell name="siret">{siret}</ListeTable.Cell>
      <ListeTable.Cell name="codeCollectivite">{codeCollectivite}</ListeTable.Cell>
      <ListeTable.Cell name="codeBudget">{codeBudget}</ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ProduitsListeTableRowDetail;
